import React from 'react'
import "./ServicesTextContent.css"
import { useNavigate } from 'react-router-dom'

function ServicesTextContent({
    subHeading="",
    heading="",
    content="",
    img="",
    shiftRow=true,
    bgColor="white",
    TickMarkList=null,
    bulletList=null,
    btn=true,
    btnText="",
    btnRef="/",
    btnCalendly=false,
    marginBottomNull=false
}) {
    const navigate = useNavigate()
  return (
    <div className={`servicesText-container standard-padding-space my-4 ${marginBottomNull && "mb-0"}`} style={{backgroundColor: bgColor}}>
        <div className='container'>
            <div className={`row gap-4 gap-md-0 d-flex ${shiftRow ? "flex-row-reverse" : ""} align-items-center justify-content-center `}>
                <div className='col-md-6 '>
                    <div className='text-content d-flex flex-column align-items-start justify-content-center h-100'>
                        {subHeading && <h5 className='sub-heading'>{subHeading}</h5>}
                        <h3 className='body-heading mb-3'>{heading}</h3>
                        <p className='body-paragraph mb-2'>{content}</p>
                        {
                            bulletList &&
                            <ul className='ps-3 mt-0 mb-3'>
                                {
                                    bulletList.map((list)=>{
                                        return(
                                            <li className='body-paragraph mb-2'>
                                                {list}
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        }
                        {
                            TickMarkList &&
                            <div className='ps-1 mt-0 mb-3 d-flex flex-column'>
                                {
                                    TickMarkList.map((list)=>{
                                        return(
                                            <div className='d-flex align-items-start gap-2 mb-1'>
                                                <img loading="lazy" src='/images/icons/blue-tick.png' alt='tick icon' className='img-fluid' />
                                                <p className='body-paragraph'>{list}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        }
                        {btn && <button className="blue-btn mt-2" onClick={()=>{if(btnCalendly){window.open("https://calendly.com/chandrancpa","blank")}else{navigate(btnRef?btnRef :"/contact")}}}>{btnText?btnText:"Get Consultation"}</button>}
                    </div>
                </div>
                <div className='col-md-6 h-100 my-auto'>
                    <img alt="content" loading="lazy" src={img} className='img-fluid' />
                </div>
            </div>
        </div>
    </div>
  )
}

export default ServicesTextContent